import { render, staticRenderFns } from "./RecruiterDashboard.vue?vue&type=template&id=7225db21&scoped=true"
import script from "./RecruiterDashboard.vue?vue&type=script&lang=ts"
export * from "./RecruiterDashboard.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterDashboard.vue?vue&type=style&index=0&id=7225db21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225db21",
  null
  
)

export default component.exports